// Generated by CoffeeScript 2.7.0
var UserBoundaryConfig;

import UserBoundarySelectorModal from 'trunks/vue/admin/components/modals/user_boundary_selector_modal.js';

export default UserBoundaryConfig = {
  props: {
    userBoundary: {
      type: Skylark.App.Model.UserBoundary,
      required: true
    },
    extraBoundaryComps: Array,
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    userBoundaryText: function() {
      if (this.userBoundary.overlord.isInitial) {
        return '发起范围';
      } else {
        return '处理者范围';
      }
    },
    boundaryPresent: function() {
      return !this.userBoundary.isEmpty();
    }
  },
  template: `<div class="config-item">
  <div class="config-item-title">
    <span class="content text-ellipsis">{{ title }}</span>
  </div>
  <div class="config-item-content" @click='openUserBoundarySelectModal'>
    <div class="user-boundary-container">
      <div class="chips" v-if='boundaryPresent'>
        <div class="chip"
             v-for='organization in userBoundary.organizations'
             :key="'organization_' + organization.id">
          {{ organization.name }}
        </div>
        <div class="chip orange"
             v-for='tag in userBoundary.user_tags'
             :key="'tag_' + tag.id">
          {{ tag.name }}
        </div>
        <br />
        <div class="chip"
             v-for='user in userBoundary.users'
             :key="'user_' + user.id">
          {{ user.name }}
        </div>
        <br />
        <div class="chip purple"
             v-for='vertex in userBoundary.reviewerVertices'
             :key="'vertex_' + vertex.id">
          {{ vertex.name }}
        </div>
        <div class="chip purple"
             v-for='vertex in userBoundary.ccVertices'
             :key="'vertex_' + vertex.id">
          {{ vertex.name }}
        </div>
      </div>
      <div class="config-placeholder" v-else @click='openUserBoundarySelectModal'>
        <span>设置范围</span>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    openUserBoundarySelectModal: function() {
      return new UserBoundarySelectorModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue("user_boundary_select_modal"),
        propsData: {
          userBoundary: this.userBoundary,
          extraBoundaryComps: this.extraBoundaryComps
        }
      }).$on('ensureClicked', (value, options) => {
        return this.$emit('valueChanged', value, options);
      });
    }
  }
};
